/* eslint-disable arrow-parens */
const btns = document.querySelectorAll('.showmore-js');
const number = 3;

function checkBtnChowMore() {
	if (btns.length) {
		btns.forEach(btn => {
			const parent = btn.parentNode;
			const allItem = parent.children;

			if (allItem.length <= 4) {
				btn.style.display = 'none';
			}
		});
	}
}

function showMore(e) {
	e.preventDefault();

	const parent = e.target.parentNode;
	const allItem = parent.children;
	let counter = 1;

	for (let i = 0; i < allItem.length; i++) {
		if (getComputedStyle(allItem[i]).display === 'none' && allItem[i] !== e.target) {
			allItem[i].style.display = 'block';
			counter++;
		}

		if (i + 1 === allItem.length - 1) {
			e.target.style.display = 'none';
		}
		if (counter > number) {
			break;
		}
	}
}

function init() {
	checkBtnChowMore();
	btns.forEach(el => {
		el.addEventListener('click', e => {
			showMore(e);
		});
	});
}

export default {
	showMore,
	checkBtnChowMore,
	init,
};
